import { useEffect, useState } from 'react'

import { helpers, returnStatuses, useFetch } from '@reveni-io/reveni-ui'

import { orderTransactionTypes } from '@/constants'
import useTransactionTypes from '@/hooks/useTransactionTypes/useTransactionTypes'
import services from '@/services/services'

const useRecommendations = ({ orderId, itemId, needsRefund, orderStatus, refundOnHold }) => {
  const { getOrderTransactionType, isInstant } = useTransactionTypes()
  const isRefundOrMixed = [orderTransactionTypes.refund, orderTransactionTypes.mixed].includes(
    getOrderTransactionType()
  )
  const [recommendations, setRecommendations] = useState({ results: [] })
  const show = isRefundOrMixed && isInstant() && needsRefund && orderStatus !== returnStatuses.onHold && !refundOnHold
  const {
    data,
    loading,
    fetchData: getRecommendedExchangeProducts,
  } = useFetch(services.getRecommendedExchangeProducts, {
    doInitialRequest: show,
    params: { orderId: orderId, itemId: helpers.getOriginalId(itemId) },
  })
  const [page, setPage] = useState(1)

  useEffect(() => {
    if (data?.results) {
      setRecommendations(recommendations => ({ ...data, results: [...recommendations.results, ...data.results] }))
    }
  }, [data])

  const handleGetMoreProducts = () => {
    if (page <= 3 && data?.next) {
      getRecommendedExchangeProducts({
        orderId: orderId,
        itemId: helpers.getOriginalId(itemId),
        page: page + 1,
      })
      setPage(page => page + 1)
    }
  }

  return {
    recommendations,
    loading,
    handleGetMoreProducts,
    show,
    showViewMore: !recommendations?.next || page === 3,
  }
}

export default useRecommendations
